module.exports = __webpack_public_path__ + "img/cq2b32-30.prt.c256baa3.jpg";